package kz.dentalcrm.app.screens.services.add.mvi

import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kz.dentalcrm.app.core.base.Selectable
import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

data class AddServiceState(
    val categories: PersistentList<Selectable<ServiceCategory>> = persistentListOf(),
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {
    sealed interface ScreenState {
        data class Error(val error: String) : ScreenState
        data object Idle : ScreenState
        data object Added : ScreenState
        data object Adding : ScreenState
        data object Loading : ScreenState
    }
}
